import BottomTabs from './BottomTabs.view';

export default BottomTabs;
